<!-- Header -->
<div class="bg-card" *transloco="let t">
  <div class="flex flex-col w-full max-w-screen-xl mx-auto px-6 sm:px-8">
    <div class="grid gap-2 grid-cols-[auto_1fr] min-w-0 my-5">
      <!-- Title -->
      <div class="flex items-center min-w-0 truencate">
        <div class="flex flex-col min-w-0 ml-4">
          <div class="text-3xl md:text-3xl tracking-tight leading-7 md:leading-snug truncate">
            {{ (titleTranslate ? t(title) : title) | capitalize }}
          </div>
          @if (subtitle) {
            <div class="leading-6 truncate text-secondary">
              {{ subtitleTranslate ? t(subtitle) : subtitle }}
            </div>
          }
        </div>
      </div>

      <!-- Botões -->
      <div class="flex justify-end items-center mt-0 space-x-2">
        <ng-content></ng-content>

        @if (buttons) {
          <hmax-button-group
            class="w-full"
            align="right"
            [useMenu]="true"
            [buttons]="buttons"
            (buttonClick)="doButtonClick($event)"
          ></hmax-button-group>
        }

        <!-- Botão 3 (esquerda) -->
        @if (button3) {
          <button class="" mat-stroked-button (click)="doButtonClick(button3)" [disabled]="button3disabled">
            @if (button2SvgIcon) {
              <mat-icon class="icon-size-5" [svgIcon]="button3SvgIcon"></mat-icon>
            }
            <span [ngClass]="{ 'hidden sm:block sm:ml-1': button3SvgIcon !== '' }">{{ t(button3) | titlecase }}</span>
          </button>
        }

        <!-- Botão 2 (esquerda) -->
        @if (button2) {
          <button class="" mat-stroked-button (click)="doButtonClick(button2)" [disabled]="button2disabled">
            @if (button2SvgIcon) {
              <mat-icon class="icon-size-5" [svgIcon]="button2SvgIcon"></mat-icon>
            }
            <span [ngClass]="{ 'hidden sm:block sm:ml-1': button2SvgIcon !== '' }">{{ t(button2) | titlecase }}</span>
          </button>
        }

        <!-- Botão 1 (direita) -->
        @if (button1) {
          <button class="dark:bg-blue-600" mat-flat-button color="primary" (click)="doButtonClick(button1)" [disabled]="button1disabled">
            @if (button1SvgIcon) {
              <mat-icon class="icon-size-5" [svgIcon]="button1SvgIcon"></mat-icon>
            }
            <span [ngClass]="{ 'hidden sm:block sm:ml-1': button1SvgIcon !== '' }">{{ t(button1) | titlecase }}</span>
          </button>
        }
      </div>
    </div>

    <!-- Project selector -->
    <!-- <div
      class="relative flex self-start pt-2 pb-1 pl-5 pr-4 cursor-pointer overflow-hidden rounded-t-xl border border-b-0 bg-default"
      matRipple [matMenuTriggerFor]="projectsMenu">
      <div class="flex items-center">
        <div class="overflow-hidden">
          <div class="font-medium leading-6 truncate">Project Test</div>
        </div>
        <div class="flex items-center justify-center pl-2">
          <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:chevron-down'"></mat-icon>
        </div>
      </div>
      <mat-menu #projectsMenu="matMenu" [xPosition]="'before'">
        <button mat-menu-item>Creapond
        </button>

      </mat-menu>
    </div> -->
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
